<div class="d-flex align-items-center justify-content-between chip-item">
    <span class="filter-title">{{ filterTitle().split('-')[0] }}</span>
    <span class="d-flex justify-content-center align-items-center remove-container">
        <img [src]="IMAGE_URLS.closeIconDark" class="remove-icon" (click)="onRemoveFilter()" />
    </span>
</div>